<!-- 最新动态 -->
<template>
  <div class="w-full flex flex-col gap-4 py-3 bg-gray">
    <!-- 栏目标题 -->
    <div class="oneTitleDiv">
      <div class="oneTitle">
        <div class="pubTitle">
          <img :src="require('@/assets/title1.png')" alt="" width="22px" height="22px"/>
          <span style="margin-left: 8px;">{{ info?.label }}</span>
        </div>
        <div class="pubTitles">
          <div style="width: 32px;height: 2px;background: #176DAA;margin-right: 10px"></div>
          {{ info?.englishName }}
        </div>
      </div>
      <div class="oneMore" @click="goMore(info?.id)">
        <img :src="require('@/assets/moreIconPro.png')" alt="" />
      </div>
    </div>
    <!-- 菜单栏 -->
    <div class="flex items-center gap-6 px-2">
      <div
        v-for="item in menuList"
        :key="item?.name"
        @click="() => (activeMenuId = item?.id)"
        :class="[
          { 'text-primary': activeMenuId === item?.id },
          activeMenuId === item?.id ? 'font-bold' : 'font-normal',
        ]"
        :style="{
          borderBottomWidth: '2px',
          borderColor: activeMenuId === item?.id ? '#194E9E' : 'transparent',
          borderStyle: 'solid',
        }"
      >
        {{ item?.label }}
      </div>
    </div>
    <!-- 内容 -->
    <div
      class="flex flex-col px-4 rounded"
      v-for="item in pageInfoList"
      :key="item?.id"
      @click="() => handleNavigateToDetail(item?.id,item?.title)"
    >
      <!-- 图片 -->
      <div class="w-full h-52">
        <img
          class="w-full h-full"
          @error="handleImageError"
          :src="'/mainsys/UserFiles/menupic/' + item?.picUrl"
        />
      </div>
      <!-- 标题及描述 -->
      <div
        class="flex flex-col p-3 gap-1 bg-white"
        :class="{
          activeCardContent: acticveId === item?.id,
        }"
      >
        <!-- <span class="font-normal text-xs" :style="{
                    color: getColor(item?.descripton)
                }">
                    {{ item?.descripton }}
                </span> -->
        <span
          class="text-primary font-black text-base"
          :style="{
            color: '#13499B',
          }"
        >
          {{ item?.title }}
        </span>
        <span
          class="font-normal text-sm"
          style="
            color: #333333;
            opacity: 0.6;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          "
          >{{ item?.descripton }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { array_ } from "../utils/index";
import mixins from "../hooks";

export default {
  name: "learningResource",
  mixins: [mixins],
  props: {
    info: {
      default: () => ({}),
    },
  },
  computed: {
    // 菜单列表
    menuList() {
      return array_(this.info?.twoData).map((item) => {
        return {
          id: item?.id,
          label: item?.label,
        };
      });
    },
    // 不同菜单对应界面信息映射关系
    mappingPageInfo() {
      return array_(this.info?.twoData).reduce(
        (acc, cur) => acc.set(cur?.id, array_(cur?.data)),
        new Map()
      );
    },
    // 根据选择的菜单选择不同的pageInfo
    pageInfoList() {
      return this.mappingPageInfo?.get(this.activeMenuId).slice(0,3);
    },
    // 当前界面列表ID集合
    pageInfoIDList() {
      return array_(this.pageInfoList).map(({ id }) => id);
    },
  },
  data() {
    return {
      acticveId: null,
      activeMenuId: null,
    };
  },
  watch: {
    // 数据加载后,默认选中第一个
    menuList: {
      immediate: true,
      handler(val) {
        if (val?.length) {
          this.activeMenuId = val[0]?.id;
        }
      },
    },
  },

  methods: {
    handleImageError(e){
      e.target.src = require('../../../assets/2.png')
    },
    goMore(id) {
      let ids = "";
      if (this.menuList && this.menuList.length > 0) {
        ids = this.menuList[0].id;
      } else {
        ids = id;
      }
      console.log(ids,'ids')
      this.$router.push({
        path: "ListTeach:menuId",
        name: "ListTeach",
        params: { menuId: ids },
      });
    },
    // 获取颜色
    getColor(str) {
      const regMap = [
        {
          reg: "省级一流",
          color: "#BB7915",
        },
        {
          reg: "国家一流",
          color: "#13499B ",
        },
      ];
      const color = array_(regMap).find(({ reg }) => str?.includes(reg))?.color;
      return color || "#13499B ";
    },
    // 切换选中信息板块
    handleChangeActiveId(id) {
      if (this.pageInfoIDList.includes(id)) {
        if (this.acticveId === id) {
          this.handleNavigateToDetail(id);
        } else {
          this.acticveId = id;
        }
      }
    },
  },
};
</script>
<style scoped>
.oneTitleDiv {
  height: 70px;
  width:100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.oneTitle {
  width: 100%;
  background-size: 100% 100%;
  background: url("~@/assets/title.png") no-repeat;
  padding-left: 24px;
}
.pubTitle {
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  font-size: 18px;
  color: #176DAA;
  letter-spacing: 3.29px;
  display: flex;
  align-items: center;
  margin-top: 15px;
  margin-left: 14px;
}
.pubTitles {
  color: #176daa;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-align: left;
  margin-left: 14px;
  display: flex;
  align-items: center;
  margin-top: -4px;
}
.oneMore {
  cursor: pointer;
  position: absolute;
  right: 15px;
  bottom:0;
  height: 34px;
  width: 94px;
}
.recentNewsTitle {
  background: url("~@/assets/title.png") no-repeat;
  background-size: 65% 100%;
}

.activeCardContent {
  background: url("~@/assets/bottomBg.jpg") no-repeat;
  background-size: cover;
}
</style>
